module.exports = __webpack_public_path__ + "static/media/02-3-c.65731c37.webp";